<template>

  <div class="v4-tpl-box">

    <modal name="controlLibraryModel" :scrollable="true" height="50%" :maxHeight="480" :adaptive="true"
           @before-close="draggable=true">
      <ControlLibraryList :controlLibraryList="controlLibraryList" :scale="scale"
                          @create="createLib"></ControlLibraryList>
    </modal>

    <modal name="controlLibraryRightModel" :scrollable="true" height="50%" :maxHeight="480" :adaptive="true"
           @before-close="draggable=true">
      <ControlLibrarySetting :item-data="click_item_data" @input="updateLibInput"
                             @input-array="updateLibArrayInput"></ControlLibrarySetting>
    </modal>

    <div class="pdf-box" :style="getPdfBoxStyle">

      <div class="pdf-pages">{{ now_page }} / {{ all_page }}</div>

      <!--     图片预览 -->
      <div class="read-pdf-box" v-for="(page, page_id) in pages" :key="page_id">
        <div v-if="page_show_version==='v1'" :page-id="page_id" class="read-pdf-box-image " :style="getImageMaxWidth"
             v-lazy:background-image="page.url" @click="pdfClick($event, page_id)"></div>
        <canvas v-else-if="page_show_version==='v2'" :page-id="page_id" class="read-pdf-box-image "
                :style="getImageMaxWidth" :id="`canvas-read-pdf-box-${page_id}`"
                @click="pdfClick($event, page_id)"></canvas>
        <div class="read-pdf-loading">
          <img src="./../assets/loading.gif">
        </div>


        <div
            v-for="(item_config,index_config) in page.config"
            :key="`config-${page_id}-${index_config}`"
            class="seal-disable max-center"
            v-show="item_config.version!=='2.0'"
            :style="{
              width : item_config.position.width * (max_page_width / item_config.position.page_width)  +'px',
              height :item_config.position.height * (max_page_width / item_config.position.page_width)  +'px',
              top : (item_config.position.page_height - item_config.position.y - item_config.position.height) * (max_page_width / item_config.position.page_width) +'px',
              left : item_config.position.x * (max_page_width / item_config.position.page_width)  +'px',
            }"
            @click="api.alert('此处的内容由您上传的pdf文件指定，您需要修改您的pdf文件才能生效，合同发起后可在此区域填写内容')"
        >
          <div :style="`transform:scale(${scale});`">禁止更改</div>
        </div>


        <template v-for="(item,index) in page.custom_config">
          <vue-draggable-resizable
              ref="vueDraggable"
              v-if="item"
              :draggable="draggable"
              :resizable="!(item.control_library_id===13 || item.control_library_id===15)"
              :lock-aspect-ratio="item.control_library_id===6 || item.control_library_id===7"
              :key="`custom-config-${page_id}-${index}`"
              :w="item.width"
              :h="item.height"
              :x="item.x"
              :y="item.y"
              :z="10"
              :min-width="20"
              :min-height="20"
              :max-width="item.width*5"
              :max-height="item.height*5"
              @resizestop="updateLibSize"
              @dragstop="updateLibPosition"
              @activated="clickLib"
              :custom-id="`${page_id},${index},${item.id}`"
              :parent="true"
              :class="[ 'border-black',  click_id===item.id ? 'border-black-hover' : ''  ]"
              :style="{ background : item.background_color  }"
          >
            <ControlLibraryContent :scale="scale" :click-id="click_id" :item="item" @delete="deleteLib"
                                   @setting="settingLib"></ControlLibraryContent>
          </vue-draggable-resizable>
        </template>
      </div>
      <!--      图片预览结束-->
      <div style="padding-bottom: 70px"></div>
    </div>

    <!--   wap 按钮-->

    <div class="right-tool-mobile" style="display: none">
      <div class="right-tool-mobile-box flex-center">
        <div style="width: 120px">
          <div class="btn" @click="viewTpl" style="background: #828282; width: 90%">预览</div>
        </div>
        <div style="width: 120px;">
          <div class="btn" @click="showLib" style="background: #828282; width: 90%">控件库</div>
        </div>
        <div style="width: 60%;  " @click="saveLib">
          <div class="btn" style="width: 85%">保存模板设置</div>
        </div>
      </div>
    </div>
    <!--    wap 按钮结束-->

    <div class="footer-box">
      <div class="footer-left">
        <div class="footer-left-ico"  @click="useZoom">
          <div >
            <img src="./../assets/images/zoom.png" >
          </div>
          <div>缩放</div>
        </div>
        <div class="footer-left-ico"  @click="viewTpl" >
          <div >
            <img src="./../assets/images/view.png" >
          </div>
          <div>预览</div>
        </div>
        <div class="footer-left-ico"  @click="showLib" >
          <div >
            <img src="./../assets/images/list.png" >
          </div>
          <div>控件库</div>
        </div>
      </div>
      <div class="footer-right"  @click="saveLib">
        <div class="btn">保存模板设置</div>
      </div>
    </div>


  </div>

</template>

<script>

function remove(e) {
  console.log(e);
}

import load from "@/conf/js/load";
import {readPdfMixins} from "@/common/readPdf/readPdfMixins";
import VueDraggableResizable from "@/components/vue-draggable-resizable";

import "@/components/vue-draggable-resizable/style.css";
import ControlLibraryList from "@/v4Template/ControlLibrary/ControlLibraryList";
import ControlLibraryContent from "@/v4Template/ControlLibrary/ControlLibraryContent";
import ControlLibrarySetting from "@/v4Template/ControlLibrary/ControlLibrarySetting";


export default {

  name: "v4Template",
  mixins: [readPdfMixins],

  mounted() {
    this.$Lazyload.$on('loaded', (evt) => {
      this.imgLoadingSuccess(evt)
    });
  },
  data() {
    return {
      controlLibraryList: [],
      nowCLickPage: {}, //当前点击页面的什么位置
      modelBoxHeight: 365,
      draggable: true, //是否能够拖动
      pages: [],
      click_id: '',
      click_item_data: {},
      tpl: {
        id: this.$route.query.id || "",
        file_id: "",
        field: []
      }
    };
  },
  components: {ControlLibrarySetting, ControlLibraryContent, ControlLibraryList, VueDraggableResizable},
  methods: {

    /**
     * 放大
     */
    useZoom() {

      let contentNoZoom = "width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, viewport-fit=cover";
      let contentZoom = "width=device-width,initial-scale=1.0, minimum-scale=yes, maximum-scale=2.0"
      let content = document.getElementsByName("viewport")[0].getAttribute("content");
      if (content === contentNoZoom)
        this.api.alert("您已经开启双指可放大功能，再次点击可关闭")
      else
        this.api.alert("您已经关闭双指可放大功能，再次点击可开启")
      document.getElementsByName("viewport")[0].setAttribute("content", content === contentZoom ? contentNoZoom : contentZoom);

    },
    /**
     * 保存设置
     */
    saveLib() {
      this.api.loading()
      this.api.post("/v1/Templates/updateV41Field", {id: this.tpl.id, field: this.pages, version: 'v4.1'}, json => {
        this.api.hideLoading()
        this.api.alert(json.msg)
      })
    },
    /**
     * 页面点击事件
     * @param e
     * @param page_id
     */
    pdfClick(e, page_id) {

      if (this.click_id)
        return this.click_id = ""
      this.now_page = page_id + 1
      this.showLib()
      this.nowCLickPage = {
        x: e.layerX,
        y: e.layerY
      }
    },
    /**
     * 更新参数内容
     */
    updateLibInput(e) {
      this.$set(this.pages[this.click_item_data.page - 1].custom_config[this.click_item_data.page_index_id], e.field, e.value)
    },
    /**
     * 数组内容更新
     */
    updateLibArrayInput(e) {
      let obj = this.pages[this.click_item_data.page - 1].custom_config[this.click_item_data.page_index_id][e.field];
      this.$set(obj[e.index], e.key, e.value)
    },

    /**
     * 显示lib
     */
    showLib() {
      this.draggable = false
      this.$modal.show('controlLibraryModel')
    },
    /**
     * 设置控件
     * @param item
     */
    settingLib(item) {
      this.draggable = false
      this.$modal.show('controlLibraryRightModel')
    },
    /**
     * 删除控件
     * @param e
     */
    deleteLib(e) {

      /**
       * 需要使用index  否则保存过后的无法删除
       */
      this.getDataById(e, (item, index) => {
        this.click_id = ""
        this.$set(this.pages[item.page - 1].custom_config, index, null)
      })
    },
    /**
     *
     * 当尺寸发生改变时
     *
     */
    updateLibSize(x, y, w, h, customId) {
      let ids = customId.split(",");
      let page_id = parseInt(ids[0])
      let index_id = parseInt(ids[1])
      this.clickLib(customId)
      this.$set(this.pages[page_id].custom_config[index_id], 'width', w)
      this.$set(this.pages[page_id].custom_config[index_id], 'height', h)
      this.$set(this.pages[page_id].custom_config[index_id], 'x', x)
      this.$set(this.pages[page_id].custom_config[index_id], 'y', y)
    },

    /**
     * 控件点击事件
     * @param customId
     */
    clickLib(customId) {

      let ids = customId.split(",");
      this.click_id = ids[2]
      this.getDataById(this.click_id, json => {
        this.click_item_data = json
      })

    },

    /**
     * 删除印章
     * @param id
     * @param successFun
     */
    getDataById(id, successFun) {

      this.pages.forEach((page, pageIndex) => {

        if (page.custom_config)
          page.custom_config.forEach((item, index) => {
            if (item && item.id === id) {
              successFun(item, index)
            }
          });
      })

    },

    /**
     * 当章停止移动时
     * @param x 坐标
     * @param y 坐标
     * @param customId 当前的ID
     */
    updateLibPosition(x, y, customId) {
      let ids = customId.split(",");
      let page_id = parseInt(ids[0])
      let index_id = parseInt(ids[1])
      this.clickLib(customId)
      this.$set(this.pages[page_id].custom_config[index_id], 'x', x)
      this.$set(this.pages[page_id].custom_config[index_id], 'y', y)
    },

    /**
     * 获取控件库列表
     */
    getLibList() {
      this.api.post("/v2/V32Templates/getControlLibrary", {}, (json) => {
        if (json.code === 200) {
          this.controlLibraryList = json.data
        } else
          this.api.msg(json.msg)
      })
    },

    /**
     * 创建lib
     * @param e
     */
    createLib(e) {

      let now_page = this.now_page - 1

      if (!this.pages[now_page].custom_config)
        this.$set(this.pages[now_page], 'custom_config', [])

      e.page_index_id = this.pages[now_page].custom_config.length

      if (this.nowCLickPage.x) {
        e.x = this.nowCLickPage.x + e.width > this.max_page_width ? this.nowCLickPage.x - e.width : this.nowCLickPage.x
        e.y = this.nowCLickPage.y + e.height > this.page_height ? this.nowCLickPage.y - e.height : this.nowCLickPage.y
      } else if (e.page_index_id >= 1 && this.pages[now_page].custom_config[e.page_index_id - 1]) {
        e.x = this.pages[now_page].custom_config[e.page_index_id - 1].x
        e.y = this.pages[now_page].custom_config[e.page_index_id - 1].y + this.pages[now_page].custom_config[e.page_index_id - 1].height + 30
        if (e.y + e.height > this.page_height)
          e.y = this.page_height * this.scale / 2
      } else {
        e.x = (this.max_page_width - e.width) / 2
        e.y = this.page_height * this.scale / 2
      }

      e.page = this.now_page
      e.page_width = this.max_page_width
      //增加到数组
      this.pages[now_page].custom_config.push(e)
      this.click_id = e.id
    },

    /**
     * view
     */
    viewTpl() {


      if (this.$route.query.client==='mobile')
        return uni.navigateTo({
          url: "/pages/users/myTemplate/v32/fill?type=view&id=" + this.$route.query.id
        })

      let url = `/#/templates/v32?id=${this.tpl.id}&fill_id=&channel=&tpl_token=&appId=${this.$route.query.appId}&orgId=${this.$route.query.orgId}&token=${this.$route.query.token}&client=${this.$route.query.client}`
      window.open(url)

    },

    /**
     * 读取数据
     */
    readDetails() {

      let data = {
        id: this.tpl.id,
        fill_id: this.fill_id,
        tpl_token: this.tpl_token
      };

      let success = json => {
        this.tpl = json.data
        this.pages = json.data.pages
      }

      this.readPdf("/v1/V32Template/read", data, success)

    }
  },
  created() {
    load.js("/js/scroll.js")
    this.readDetails()
    this.getLibList()
  }

};
</script>
<style scoped>

@import url('./../common/readPdf/style.css');
@import url('./../assets/style/footBar.css');

.v4-tpl-box {
  overflow: hidden;
  height: 100%;
  min-height: 100%
}


.flex-center {
  /*justify-content: flex-start | flex-end | center | space-between | space-around;*/
  justify-content: center;
}


.fill-success img {
  width: 60px;
}

.seal-personal {
  width: 88.6px !important;
  height: 88.6px !important;
}

.seal-company {
  width: 142.6px !important;
  height: 142.6px !important;
}

.border-black {
  border: 1px dashed var(--blue);
  border-radius: 1px;
  background: #ffffff;
  opacity: 0.9;
}


.seal-disable {
  position: absolute;
  border: 0.5px dashed #dddddd;
  border-radius: 1px;
  background: #dbdbdb;
  color: #585858;
  font-size: 10px;
  opacity: 0.9;
  text-align: center;
}

.border-black-hover {
  border: 1px dashed #e61717 !important;
  border-radius: 1px;
  background: #ffffff;
  opacity: 0.9;
  z-index: 12 !important;
}

.border-black .handle {
  display: none !important;
  background: #ffffff;
}

.border-black-hover .handle {
  border: 1px dashed #e61717 !important;
  display: block !important;
}


</style>
